import script from "./DesktopDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesktopDetails.vue?vue&type=script&setup=true&lang=ts"

import "./DesktopDetails.vue?vue&type=style&index=0&id=3fc582c0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fc582c0"]])

export default __exports__